import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';

import Logo from '../resources/logo.png';
import { useKeycloak } from '../KeycloakContext';
import { useSession } from '../SessionContext';

function SignIn() {
    const {
        initialized,
        authenticated,
        login,
    } = useKeycloak();

    const {
        session,
        sessionLoaded,
    } = useSession();

    const loginStartedRef = useRef(false);

    useEffect(() => {
        if (
            initialized
            && !authenticated
            && !loginStartedRef.current
        ) {
            loginStartedRef.current = true;
            login();
        }
    }, [
        initialized,
        authenticated,
        login,
    ]);

    if (
        initialized
        && authenticated
        && sessionLoaded
        && session
    ) {
        return (
            <Navigate
                to="/dashboard"
                replace
            />
        );
    }

    return (
        <div className="login-container">
            <div className="login-box">
                <img
                    className="login-logo"
                    src={Logo}
                    alt="Conduril"
                />

                <div className="loading-container">
                    <TailSpin
                        height="50"
                        width="50"
                        color="#0c1534"
                        ariaLabel="A autenticar"
                    />
                </div>

                <p>
                    A iniciar sessão no Olympus...
                </p>
            </div>
        </div>
    );
}

export default SignIn;